import React from "react";
import PaymentService from "./PaymentService";
import ShowPopup from "./ShowPopup";
const config = require('../config')
const PaymentObj = new PaymentService();

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    console.log("props", props);

    this.state = {
      isEmailValid: true,
      message : '',
      showPopup : false
    };
  }

  validateEmail = (email) => {
    if (typeof email !== "undefined") {
      //regular expression for email validation
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(email)) {
        this.setState({ isEmailValid: false });
        return false;
        //   "Please enter valid email-ID to continue.";
      } else {
        this.setState({ isEmailValid: true });
        return true;
      }
    } else {
      this.setState({ isEmailValid: false });
      return false;
    }
  };

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    console.log("Route Params", params);
    this.setState({ enquiryCode: params.enquiryCode });
    window.addEventListener("beforeunload", (event) => { 
      this.beforePageDestroyed()
      //event.returnValue = 'Do you want to close';
    });
    window.addEventListener("unload", this.beforePageDestroyed);

    this.getAmount(params.enquiryCode);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.beforePageDestroyed);
    window.removeEventListener("unload", this.beforePageDestroyed);
  }

  beforePageDestroyed = async () => {
    try {
      if (this.state.order_id) {
        let formData = new FormData();
        formData.append("orderID", this.state.order_id);
        let response = await PaymentObj.rejectOrder(formData);
      }
    } catch (error) {}

    localStorage.setItem("destroyed", "a");
  };

  getAmount = async (enquiryCode) => {
    try {
      //let enquiryCode = "P21111602466220";
      let response = await PaymentObj.getAmount(enquiryCode);
      console.log("amount", response);
      this.setState({
        amount: response.amount,
        enquiryCode: response.enquiryCode,
      });
    } catch (error) {
      console.log(error);
      this.setState({showPopup: true, message : error.data.message})
      // let message = window.confirm(error.data.message);
      // if (message) {
      //   window.location = "https://www.firstcryintellitots.com/";
      // } else {
      //   window.location = "https://www.firstcryintellitots.com/";
      // }
    }
  };

  getOrderId = async () => {
    if (this.validateEmail(this.state.emailId)) {
      let formData = new FormData();
      formData.append("enquiryCode", this.state.enquiryCode);
      formData.append("emailID", this.state.emailId);
      formData.append("amount", this.state.amount);

      try {
        let response = await PaymentObj.getOrderId(formData);
        this.setState({ order_id: response.orderID });
        this.proceedPayment(response.orderID);
      } catch (error) {
        console.log(error);
        //let message = window.confirm(error.data.message);
        this.setState({showPopup: true, message : error.data.message})

        // if (message) {
        //   window.location = "https://www.firstcryintellitots.com/";
        // } else {
        //   window.location = "https://www.firstcryintellitots.com/";
        // }
      }
    }
  };
  paymentComplete = async (resp) => {
    console.log("response", resp);
    if (resp?.razorpay_payment_id) {
      console.log(resp.razorpay_payment_id);
      console.log(resp.razorpay_order_id);
      console.log(resp.razorpay_signature);
      let formData = new FormData();
      formData.append("paymentID", resp.razorpay_payment_id);
      let response = await PaymentObj.capturePayment(formData);
      if (response.paymentOrderData) {
      this.setState({showPopup: true, message : "Payment Succesful! Thank you for the payment", order_id: ""})
        // alert("Thank you for the payment")
        // window.location = "https://www.firstcryintellitots.com/";
        // this.setState({ order_id: "" });
      }
    } else {
      this.beforePageDestroyed();
    }
  };
  handleFailed = (r) => {
    console.log("response failed", r);
    this.beforePageDestroyed();
    //this.setState({showPopup: true, message : "Payement failed. Please try again"})
  };

  proceedPayment = (orderId) => {
    var options = {
      key: config.razorpayKey, // Enter the Key ID generated from the Dashboard
      amount: `${this.state.amount}`, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "Firstcry Intellitots",
      description: "Transaction for BridgeCourse",
      image: "https://www.firstcryintellitots.com/wp-content/uploads/2021/04/intellitots-logo-desktop-140x77.png",
      order_id: `${orderId}`, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: (response) => this.paymentComplete(response),
      modal: {
        ondismiss: () => this.beforePageDestroyed()
    },
      prefill: {
        name: "",
        email: `${this.state.emailId}`,
        contact: "",
      },
      notes: {
        address: "",
      },
      theme: {
        color: "#3399cc",
      },
    };
    let rzp = new window.Razorpay(options);
    rzp.open();

    rzp.on("payment.failed", (response) => this.handleFailed(response));
  };

  emailHandler = (e) => {
    this.setState({ emailId: e.target.value });
  };
  onAction = () => {
    window.location = "https://www.firstcryintellitots.com/"
  }

  render() {
    return (
      // marginTop:(window.innerWidth/1.2)-96
      <React.Fragment>
        <div className="paymentContainer">
          <img className="image col-12" alt="" />
          <div className="card-shadow border  bg-white">
            <p className="pt-27 B13ff7043 B26ff7043"> THANK YOU FOR YOUR ENQUIRY.</p>
            <p className="pb-20 mr-20 ml-15 R1421 SB30321">
              {" "}
              Our counsellor will<br></br>
              get back to you soon
            </p>
          </div>
        </div>
        <div style={{ position: "relative", top: "93px" }}>
          <img
            src="https://cdn.fcglcdn.com/brainbees/intelli/firstcryintellitots/production/images/paymentBorder.png"
            width="100%"
            height="10%"
            alt=""
          ></img>
        </div>
        <div className="paymantBlock">
          <div className="text-center pt-10">
            <p className="eBold36White eBold18White">
              Yay! You're just one step away! Now purchase the Bridge Course
              directly by clicking on the button below.<br></br> Hurry up!
            </p>
          </div>
          <div className="row ml-auto mr-auto ps-3 pe-3">
            <div
              className="col-md-6 col-lg-6 col-sm-12 col-xs-12"
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <div className="parent">
                <div className="fordesktop">
                  <p className="eBold3642 eBold1842">Program fees as low as</p>
                </div>
                <div className="proceedtoPaymant">
                  <div className="pencilImg">
                    <img
                      src="https://cdn.fcglcdn.com/brainbees/intelli/firstcryintellitots/production/images/Pencil.png"
                      width="90px"
                      height="10px"
                      alt=""
                    />
                  </div>
                  <p className="desktopDisplay EB1542">Starting as low as </p>
                  <div className="d-flex" style={{ justifyContent: "center" }}>
                    <div
                      className="R1861 desktopDisplay"
                      style={{ marginTop: "4px", marginRight: "10px" }}
                    >
                      {/* <del>Rs.5000</del> */}
                    </div>
                    <div className="eBold32e53935 EB20e53 priceMargin">
                      Rs. {this.state.amount} <span className="EB22e53">only</span>
                    </div>
                    <div className="triagleimg">
                      <img
                        src="https://cdn.fcglcdn.com/brainbees/intelli/firstcryintellitots/production/images/triangle.png"
                        width="60"
                        height="50"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="mt-35 col-sm-12 col-xs-6 col-lg-10 col-md-6 p-0">
                    <input
                      className="inputStyle"
                      onChange={this.emailHandler}
                      type="text"
                      placeholder="*Please enter your email id"
                    ></input>
                      {this.state.isEmailValid ?"":<span style={{ color: "red" }}> Please enter valid email id to proceed </span>}

                  </div>
                  <div
                    className="btnstyle mt-35 col-sm-6 col-xs-6 col-lg-6 col-md-6 p-0 me-auto ms-auto"
                    onClick={() => this.getOrderId()}
                  >
                    <span className="text-center eBold20WHite">
                      PROCEED TO PAYMENT
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-6 col-12 col-md-6 d-flex"
              style={{ flexDirection: "row", justifyContent: "center" }}
            >
              <div className="instuctionclass">
                <ul className="" style={{ textAlign: "left" }}>
                  <li className="B1842">12-week Program</li>
                  <li className="R1875">
                    <span className="B1842">Daily 1 hour</span> live classes
                  </li>
                  <li className="R1875">
                    Daily <span className="B1842">half an hour</span> fun{" "}
                    <span className="B1842">at-home activities </span>
                  </li>
                  <li className="R1875">
                    Cerificate of completion at the end of the course
                  </li>
                  <li className="R1875">
                    Bridge course kit (Nursery, PP1 and PP2)
                  </li>
                  <li className="R1875">
                    Engaging interactions with teachers and friends
                  </li>
                  <li className="R1875">Regular progress tracking</li>
                </ul>
              </div>
            </div>

          { this.state.showPopup && <ShowPopup message={this.state.message} onAction={() => this.onAction()}>

           </ShowPopup>}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Payment;
